import * as microsoftTeams from '@microsoft/teams-js';
import * as msal from '@azure/msal-browser';

/* @ngInject */
export default class {
  constructor($q, $window, ApiClass, $state) {
    this.$q = $q;
    this.$window = $window;
    this.$state = $state;
    this.ApiClass = ApiClass;
    this.clientId = AZURE_PROLAERA_TEAMS_TAB_APP_ID;
  }

  // Is it running inside MS Teams tab?
  inTeams() {
    return !!(
      (this.$window.parent === this.$window.self && this.$window.nativeInterface) ||
      this.$window.name === 'embedded-page-container' ||
      this.$window.name === 'extension-tab-frame'
    );
  }

  // 1. Get auth token
  // Ask Teams to get us a token from AAD
  getClientSideToken() {
    return new this.$q((resolve, reject) => {
      microsoftTeams.authentication
        .getAuthToken()
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject('Error getting MS Teams token: ' + error);
        });
    });
  }

  // 2. Exchange that token for a token with the required permissions
  //    using the web service (see /auth/token handler in app.js)
  getServerSideToken(clientSideToken) {
    return new this.$q((resolve, reject) => {
      microsoftTeams.app.getContext().then(context => {
        const postBody = {
          tid: context.user.tenant.id,
          token: clientSideToken
        };
        return this.ApiClass.authIdTypePost({ id: 'id', type: 'msteams_sso' }, postBody)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(error => {
            return reject('Error on MS Teams SSO server-side: ' + error);
          });
      });
    });
  }

  // 3. Show the consent pop-up
  consentPopupCall() {
    return new this.$q((resolve, reject) => {
      microsoftTeams.authentication
        .authenticate({
          url: window.location.origin + '/msteamstab/consent_start',
          width: 600,
          height: 535
        })
        .then(tokenData => resolve(tokenData))
        .catch(error => reject(error));
    });
  }

  // 4. Pop-up script start
  consentPopupStart() {
    microsoftTeams.app.initialize().then(() => {
      // Get the tab context, and use the information to navigate to Azure AD login page
      microsoftTeams.app.getContext().then(context => {
        return new this.$q((resolve, reject) => {
          let scope = 'User.Read email openid profile offline_access';
          let loginHint = context.user.loginHint;

          const msalConfig = {
            auth: {
              clientId: this.clientId,
              authority: `https://login.microsoftonline.com/${context.user.tenant.id}`,
              navigateToLoginRequestUrl: false
            },
            cache: {
              cacheLocation: 'sessionStorage'
            }
          };

          const msalInstance = new msal.PublicClientApplication(msalConfig);
          const scopesArray = scope.split(' ');
          const scopesRequest = {
            scopes: scopesArray,
            redirectUri: window.location.origin + '/msteamstab/consent_end',
            loginHint: loginHint
          };
          msalInstance.loginRedirect(scopesRequest).then(() => resolve());
        });
      });
    });
  }

  // 5. Pop-up script end
  consentPopupEnd() {
    microsoftTeams.app.initialize().then(() => {
      microsoftTeams.app.getContext().then(context => {
        return new this.$q((resolve, reject) => {
          const msalConfig = {
            auth: {
              clientId: this.clientId,
              authority: `https://login.microsoftonline.com/${context.tid}`,
              navigateToLoginRequestUrl: false
            },
            cache: {
              cacheLocation: 'sessionStorage'
            }
          };

          const msalInstance = new msal.PublicClientApplication(msalConfig);
          msalInstance
            .handleRedirectPromise()
            .then(tokenResponse => {
              if (tokenResponse !== null) {
                microsoftTeams.authentication.notifySuccess(
                  JSON.stringify({
                    sessionStorage: sessionStorage
                  })
                );
              } else {
                microsoftTeams.authentication.notifyFailure('Get empty response.');
              }
              resolve();
            })
            .catch(error => {
              microsoftTeams.authentication.notifyFailure(JSON.stringify(error));
              reject();
            });
        });
      });
    });
  }

  ssologin() {
    return new this.$q((resolve, reject) => {
      microsoftTeams.app.initialize().then(() => {
        this.getClientSideToken().then(clientSideToken => {
          this.getServerSideToken(clientSideToken)
            .then(data => {
              if (data.invalid_grant) {
                resolve('invalid_grant');
              } else {
                resolve(data);
              }
            })
            .catch(data => reject(data));
        });
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/MsTeamsClass.js